import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import { computed, get } from "@ember/object"
import { inject as service } from "@ember/service"
import type { CardStack } from "@shared/models/card-stack"
import _ from "lodash"
import findMany from "../../../../../helpers/find-many"

@tagName("")
export default class ChangeClassOrderProvider extends Component {
  routine!: CardStack

  @service("ember-store") store

  @computed("routine.attributes.cards.length")
  get courseIds() {
    let cards = get(get(get(this, "routine"), "attributes"), "cards")

    return _.chain(cards)
      .filter((card) => card.type === "card-course-slot")
      .map((card) => card.attributes.courseId)
      .value()
  }

  @findMany("courseIds", "course") courses
}
